module.exports = __webpack_public_path__ + "fonts/Manrope-700-latin24.02fde8a.woff2";